module.exports = __webpack_public_path__ + "fonts/icomoon-c37d78.ttf";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/icomoon.ttf?v=1.0.0
// module id = 813
// module chunks = 2